import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={SearchX}
      title="Page not found"
      description="The address does not match any page."
      action={
        <Button asChild variant="outline">
          <Link to="/">Back to the dashboard</Link>
        </Button>
      }
    />
  );
}
